import React, { useRef } from 'react';
import { Calendar, ConfigProvider } from 'antd-mobile';
import { BringgMobileCalendarProps } from '../../bringg-calendar.types';
import getMinMaxPage from '../../helpers/get-min-max-page';
import enUS from 'antd-mobile/cjs/locales/en-US';
import moment from 'moment';

const hideYearNavigationComponentsProps = {
	prevYearButton: null,
	nextYearButton: null
};

const BringgMobileCalendar = ({
	value,
	allowClear,
	showYearNavigation,
	selectionMode,
	weekStartsOn,
	onChange,
	shouldDisableDate,
	minDateNav,
	maxDateNav,
	locale,
	timezone,
	className
}: BringgMobileCalendarProps) => {
	const calendarRef = useRef(null);

	let prevYearButton, nextYearButton;
	if (!showYearNavigation) ({ prevYearButton, nextYearButton } = hideYearNavigationComponentsProps);

	const onChangeDate = (date: Date | [Date, Date]) => {
		if (Array.isArray(date)) {
			onChange([moment(date[0]), moment(date[1])]);
		}

		return onChange(moment(date as Date));
	};

	return (
		<ConfigProvider locale={enUS}>
			<Calendar
				ref={calendarRef}
				value={value}
				allowClear={allowClear}
				onChange={date => onChangeDate(date)}
				selectionMode={selectionMode}
				className={className}
				minPage={minDateNav && getMinMaxPage(minDateNav, locale, timezone)}
				maxPage={maxDateNav && getMinMaxPage(maxDateNav, locale, timezone)}
				weekStartsOn={weekStartsOn}
				shouldDisableDate={date => shouldDisableDate(moment(date))}
				prevYearButton={prevYearButton}
				nextYearButton={nextYearButton}
			/>
		</ConfigProvider>
	);
};

export default BringgMobileCalendar;
